import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16a8c30e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "current",
  tabindex: "-1"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "6",
  viewBox: "0 0 12 6"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-arrow-down" })
], -1))
const _hoisted_4 = { class: "submenu__wrapper submenu__wrapper--left" }
const _hoisted_5 = { class: "submenu" }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["LangChooser submenu__trigger", { 'active': this.active && _ctx.Viewport.isMobile }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createElementVNode("button", _hoisted_1, [
      _createElementVNode("span", {
        innerHTML: _ctx.current.label
      }, null, 8, _hoisted_2),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
          return (_openBlock(), _createElementBlock("li", {
            key: option.slug
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.reload ? 'a' : 'button'), {
              href: _ctx.reload ? '?lang=' + option.slug : null,
              onClick: ($event: any) => (_ctx.reload ? null : _ctx.choose(option.slug))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  innerHTML: option.option
                }, null, 8, _hoisted_6)
              ]),
              _: 2
            }, 1032, ["href", "onClick"]))
          ]))
        }), 128))
      ])
    ])
  ], 2)), [
    [_directive_click_outside, _ctx.onClickOutside]
  ])
}